export default "__VITE_ASSET__DYUYhpRc__"